import React from "react";
import "./creditdashboard.scss";
import { Accordion, Offcanvas } from "react-bootstrap";
import DataTable from "../../../components/landing/Creditdashboard/DataTable/DataTable";
import { DateRange } from "react-date-range";
import DashboardTopCards from "./DashboardTopCards";
import { times } from "../../../utils/Constants";
import useCreditDashboardData from "../../../hooks/Refund/useCreditDashboardData";
const Creditdashboard = () => {
  const {
    show3,
    handleClose3,
    handleShow3,
    startDate,
    endDate,
    activeKey,
    setActiveKey,
    state,
    setState,
    stats,
    selectedTime,
    showDateFilter,
    dateFilterLabel,
    formatDates,
    fetchStats,
    applyFilters,
    clearFilters,
    handleTimeSelect,
    removeDateFilter,
    tableKey,
    refreshTable,
  } = useCreditDashboardData();



  return (
    <>
      <section className="creditdashboard">
        <div className="custom-container">
          <div className="topheadings">
            <div className="leftheadings">
              <p className="toppara">CREDITS REFUND</p>
              <h4 className="dashboardhead">Dashboard</h4>
            </div>
            <div className="forflexbutton">
              {showDateFilter && (
                <span className="filterspan">
                  <span className="strongpara">Date Filter:</span>{" "}
                  <span className="innerspan">{dateFilterLabel}</span>{" "}
                  <button className="crossbtn" onClick={removeDateFilter}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M10.8511 13.5L7.87234 9.1898L5.10638 13.5H3L6.78723 7.59592L3.25532 2.5H5.40426L8.08511 6.38367L10.617 2.5H12.7021L10.1064 6.40612H8.10638L13 13.5H10.8511Z"
                        fill="#02171D"
                      />
                    </svg>
                  </button>
                </span>
              )}
              <button onClick={handleShow3} className="filterbtn">
              <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M7.29339 15.1C6.97339 15.1 6.66006 15.02 6.36672 14.86C5.78006 14.5334 5.42672 13.94 5.42672 13.2734V9.74002C5.42672 9.40669 5.20672 8.90669 5.00006 8.65336L2.50672 6.01336C2.08672 5.59336 1.76672 4.87336 1.76672 4.33336V2.80002C1.76672 1.73336 2.57339 0.900024 3.60006 0.900024H12.4001C13.4134 0.900024 14.2334 1.72002 14.2334 2.73336V4.20002C14.2334 4.90002 13.8134 5.69336 13.4201 6.08669L10.5334 8.64002C10.2534 8.87336 10.0334 9.38669 10.0334 9.80002V12.6667C10.0334 13.26 9.66006 13.9467 9.19339 14.2267L8.27339 14.82C7.97339 15.0067 7.63339 15.1 7.29339 15.1ZM3.60006 1.90002C3.13339 1.90002 2.76672 2.29336 2.76672 2.80002V4.33336C2.76672 4.58002 2.96672 5.06002 3.22006 5.31336L5.76006 7.98669C6.10006 8.40669 6.43339 9.10669 6.43339 9.73336V13.2667C6.43339 13.7 6.73339 13.9134 6.86006 13.98C7.14006 14.1334 7.48006 14.1334 7.74006 13.9734L8.66672 13.38C8.85339 13.2667 9.04006 12.9067 9.04006 12.6667V9.80002C9.04006 9.08669 9.38672 8.30002 9.88672 7.88002L12.7401 5.35336C12.9667 5.12669 13.2401 4.58669 13.2401 4.19336V2.73336C13.2401 2.27336 12.8667 1.90002 12.4067 1.90002H3.60006Z"
                        fill="black"
                      />
                      <path
                        d="M3.99995 7.16664C3.90661 7.16664 3.81995 7.13997 3.73328 7.09331C3.49995 6.94664 3.42661 6.63331 3.57328 6.39997L6.85995 1.13331C7.00661 0.899972 7.31328 0.826639 7.54661 0.973306C7.77995 1.11997 7.85328 1.42664 7.70661 1.65997L4.41995 6.92664C4.32661 7.07997 4.16661 7.16664 3.99995 7.16664Z"
                        fill="black"
                      />
                    </svg>
                Filters
              </button>
            </div>
          </div>
          <div className="top-cards">
            <DashboardTopCards stats={stats} startDate={startDate} endDate={endDate} />
          </div>
          <h6 className="latesthead">Latest transactions</h6>

          <DataTable key={tableKey} startDate={startDate} endDate={endDate} />
        </div>
      </section>

      <Offcanvas
        show={show3}
        onHide={handleClose3}
        placement="end"
        className="leadersfilter"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Filters</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Accordion activeKey={activeKey} onSelect={(e) => setActiveKey(e)}>
            <Accordion.Item eventKey="0">
              <Accordion.Header>
                <div className="headmain">
                  <div
                    className="sqauremain"
                    style={{
                      borderColor: activeKey === "0" ? "#329879" : "#485A5F",
                    }}
                  >
                    {activeKey === "0" && <span className="innerspan"></span>}
                  </div>
                  <p className="mainpara">Filter by Date</p>
                </div>
              </Accordion.Header>
              <Accordion.Body>
                <div>
                  <DateRange
                    editableDateInputs={true}
                    onChange={(item) => {
                      formatDates([item.selection]);
                    }}
                    moveRangeOnFirstSelection={false}
                    ranges={state}
                  />
                </div>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="1">
              <Accordion.Header className="lastchild">
                <div className="headmain">
                  <div
                    className="sqauremain"
                    style={{
                      borderColor: activeKey === "1" ? "#329879" : "#485A5F",
                    }}
                  >
                    {activeKey === "1" && <span className="innerspan"></span>}
                  </div>
                  <p className="mainpara">Filter by Time</p>
                </div>
              </Accordion.Header>
              <Accordion.Body>
                <div className="timemain">
                  {times.map((time) => (
                    <div
                      key={time}
                      className={`timeinner ${selectedTime === time ? "active" : ""
                        }`}
                      onClick={() => handleTimeSelect(time)}
                    >
                      <p className="timepara">{time}</p>
                      {selectedTime === time && (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="17"
                          viewBox="0 0 16 17"
                          fill="none"
                        >
                          <path
                            d="M3 8.5L6.66235 12.5L14 4.5"
                            stroke="black"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      )}
                    </div>
                  ))}
                </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
          <div className="bottombtns">
            <button className="whitebtn" onClick={clearFilters}>
              Clear all
            </button>
            <button className="greybtn" onClick={applyFilters}>
              Apply
            </button>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default Creditdashboard;